import validate from "./validate/validate";
import file from "./file/file";
import people from "./people";
import color from "./color/color";
import oss from "./oss/oss"

let jtool = {
    file,
    validate,
    people,
    color,
    oss
}

export default {
    install (Vue) {
        Vue.jtool = Vue.prototype.$jtool = jtool
    }
}
